import React from 'react'
import {Link} from 'react-router-dom';
const WelcomeCard = () => {
    return ( 
        <div className="card">
        <div className="card-body">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="jumbotron">
                            <h1 className="display-4">Welcome to the NEC Alumni Association</h1>
                            <p className="lead">I think the success of any campus can be measured by the contribution the alumni make to our campus. <br></br> - John F. Kennedy</p>
                            <hr className="my-4" />
                            <p>Explore upcoming, ongoing and past event oraganised with our alumni's.</p>
                            {/* <p className="lead">
                                <Link to="/gallary" className="btn btn-primary btn-lg" href="#" role="button"><i className="fa-solid fa-images"></i> Gallery</Link>
                            </p> */}
                        </div>
                    </div>
                </div>
            </div>        
        </div>
    </div>
     );
}
 
export default WelcomeCard;